{
  "Users": "Användare",
  "confirm-password-generation": "Är du säker på att du vill skapa ett nytt lösenord för {{email}}?",
  "password-error": "Ett fel inträffade med ditt lösenord:\n{{message}}",
  "generated-password": "Skapat lösenord: {{password}}",
  "confirm-status-change": "Är du säker på att du vill ändra status från {{fromStatus}} till {{toStatus}} för {{email}}?",
  "status-error": "Ett fel inträffade med din status:\n{{message}}",
  "impersonate-error": "Ett fel inträffade med imitering av användare",
  "Invite": "Bjuda",
  "Id": "ID",
  "Email": "E-post",
  "Status": "Status",
  "Realm": "Realm",
  "Last active": "Senast aktiv",
  "Created": "Skapad",
  "Has password": "Lösenord",
  "Groups": "Grupper",
  "Active from": "Aktiv från",
  "Active to": "Aktiv till",
  "Created from": "Skapad från",
  "Created to": "Skapad till",
  "Lacks password": "Lösenord",
  "Password expired": "Lösenord har gått ut",
  "found-users": "Hittade {{count}} användare",
  "User status": "Användarstatus",
  "Generate password": "Skapa lösenord",
  "Deactivated": "Ej aktiverad",
  "Enter your search parameters above and click \"Search\"": "Ange sökparametrar ovanför och klicka på \"Sök\"",
  "No users found": "Inga användare funna",
  "Impersonate user": "Imitera användare",

  "Title": "Titel",
  "Type": "Typ",
  "Platform": "Plattform",
  "Enrolled": "Anmäld",
  "Started": "Påbörjad",
  "Progress": "Framsteg",
  "Completed": "Avklarad",
  "Expired": "Utgången",

  "Reset E-Learning state": "Återställ sparad position",
  "Create completion": "Skapa avklarande",
  "Void all progress": "Ta bort sparade framsteg",

  "delete-xapi-state-modal-header": "Återställ sparad position i lärande",
  "delete-xapi-state-modal-message": "Detta kommer återställa den sparade positionen användaren har i det här lärandet och låta dem börja om på nytt. Rensar ej ut sparade framsteg",
  "create-completion-modal-header": "Skapa avklarande",
  "create-completion-modal-message": "Detta kommer skapa ett avklarande på det här lärandet för den valda registreringen",
  "void-progress-modal-header": "Ta bort sparade framsted",
  "void-progress-modal-message": "Detta kommer ta bort alla sparade framsteg användaren har på det här lärandet för den valda registreringen",

  "role": "Role",
  "role-user": "User",
  "role-user-description": "Can access all the content available to their organization",
  "role-admin": "Admin",
  "role-admin-description": "Has full administrative rights to their organization",
  "role-super-admin": "Super Admin",
  "role-super-admin-description": "Has full administrative rights to all organizations",
  "change-role-header": "Change role"
}
